import { useMemo } from 'react';
import { pick } from 'ramda';

import { languageService } from 'js/services/language.service';
import { useAppSelector, useDeviceSelector, useUserSelector } from 'js/store/hooks';

export const useLoginRequest = () => {
    const { lang } = useUserSelector(pick(['lang']));
    const { clientPlatform, deliveryPlatform } = useDeviceSelector(pick(['clientPlatform', 'deliveryPlatform']));
    const { realMode, casinoName, clientVersion, clientType } = useAppSelector(pick(['realMode', 'casinoName', 'clientVersion', 'clientType']));

    return useMemo(() => {
        if (!lang || !clientPlatform || !deliveryPlatform || !casinoName) {
            return null;
        }

        return {
            realMode,
            casinoName,
            clientVersion,
            clientPlatform,
            clientType: clientType || 'casino',
            languageCode: languageService.convertToIMS(lang),
            deliveryPlatform: deliveryPlatform.slice(0, 50)
        };
    }, [
        realMode, casinoName, clientVersion,
        lang, clientPlatform, deliveryPlatform, clientType
    ]);
};
